import { motion } from "framer-motion";
import { LayoutGrid } from "lucide-react";
import { DOCTORS } from "@/data/mockData";

export const DoctorTabs = ({ active, setActive, counts }) => {
  const tabs = [
    { id: "all", label: "Visão Geral", specialty: null, avatar: null, icon: LayoutGrid },
    ...DOCTORS.map((d) => ({
      id: d.id,
      label: d.name,
      specialty: d.specialty,
      avatar: d.avatar,
    })),
  ];

  return (
    <div className="flex flex-wrap items-center gap-2 rounded-2xl border border-slate-200/70 bg-white p-1.5 shadow-sm">
      {tabs.map((tab) => {
        const isActive = active === tab.id;
        return (
          <button
            key={tab.id}
            data-testid={`doctor-tab-${tab.id}`}
            onClick={() => setActive(tab.id)}
            className={`relative flex items-center gap-2.5 rounded-xl px-3.5 py-2 text-sm font-semibold transition-colors duration-200 ${
              isActive ? "text-slate-900" : "text-slate-500 hover:text-slate-800"
            }`}
          >
            {isActive && (
              <motion.span
                layoutId="doctor-tab-pill"
                className="absolute inset-0 rounded-xl bg-slate-100"
                transition={{ type: "spring", stiffness: 400, damping: 32 }}
              />
            )}
            <span className="relative flex items-center gap-2.5">
              {tab.avatar ? (
                <img
                  src={tab.avatar}
                  alt={tab.label}
                  className="h-6 w-6 rounded-full object-cover ring-1 ring-slate-200"
                />
              ) : (
                <tab.icon className="h-4 w-4" />
              )}
              <span className="flex flex-col items-start leading-none">
                <span>{tab.label}</span>
                {tab.specialty && (
                  <span className="mt-0.5 text-[10px] font-medium text-slate-400">
                    {tab.specialty}
                  </span>
                )}
              </span>
              <span
                className={`ml-1 rounded-full px-1.5 py-0.5 text-[10px] font-bold ${
                  isActive ? "bg-blue-600 text-white" : "bg-slate-100 text-slate-500"
                }`}
              >
                {counts[tab.id] ?? 0}
              </span>
            </span>
          </button>
        );
      })}
    </div>
  );
};
